import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
// 引入nike字库
import './assets/gc-bi/font/webfonts/stylesheet.css'
import VConsole from 'vconsole'

import App from './App.vue'
import router from './router'
// import { createDebugPanel } from './utils/debugPanel'

// const vConsole = new VConsole()
// function mountHideVConsoleButton() {
//   const hideConsoleBtn = document.createElement('button')
//   hideConsoleBtn.type = 'button'
//   hideConsoleBtn.textContent = '隐藏控制台'
//   hideConsoleBtn.setAttribute('aria-label', '隐藏控制台')
//   hideConsoleBtn.style.cssText = [
//     'position:fixed',
//     'right:12px',
//     'bottom:80px',
//     'z-index:2147483646',
//     'padding:8px 12px',
//     'font-size:12px',
//     'line-height:1.2',
//     'border:none',
//     'border-radius:6px',
//     'background:#333',
//     'color:#fff',
//     'opacity:0.92',
//     'box-shadow:0 2px 8px rgba(0,0,0,0.25)',
//     'cursor:pointer',
//   ].join(';')
//   hideConsoleBtn.addEventListener('click', () => {
//     vConsole.destroy()
//     hideConsoleBtn.remove()
//   })
//   document.body.appendChild(hideConsoleBtn)
// }
// if (document.body) {
//   mountHideVConsoleButton()
// } else {
//   document.addEventListener('DOMContentLoaded', mountHideVConsoleButton, { once: true })
// }

/**-------------------------------------------------- */

// createDebugPanel({
//   enabled: true,              // 默认关闭
//   enableByQueryKey: "debug",   // ?debug=1 开启
//   enableByLocalStorageKey: "DEBUG_PANEL",
//   persist: true,
// });


const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
